import React from 'react';
import classnames from 'classnames';
import HelperTip from './HelperTip';
import * as html from '../../util/html';
import * as helper from '../../util/helper';
import './index.scss';

class FormHelper extends React.Component {
  constructor(props) {
    super(props);
    this.handleExpand = this.handleExpand.bind(this);
    this.onTouchTap = this.onTouchTap.bind(this);
    this.state = {
        expandStatus: ''
    };
  }

  componentDidMount() {
    if (this.refs.helperContent && this.refs.helperContent.clientHeight > 60) {
      this.setState({ expandStatus: 'fold' });
    }
  }
  onTouchTap() {
    const { linkAddress } = this.props;
    helper.pageJump(linkAddress, { openModel: '_blank', isCustomLink: true });
  }
  renderHelper() {
    const { expandStatus } = this.state;
    const {
      title = '',
      content = '',
      linkAddressLable,
      linkAddress
    } = this.props;
    const hasHelperContent = content || (linkAddressLable && linkAddress);
    return title || hasHelperContent ?
      <div className='helper-area'>
        {title ? <div className={classnames('helper-title',{ 'helper-only-title': title && !hasHelperContent })}><pre className='pre-html'>{html.decode(title)}</pre></div> : null}
        {hasHelperContent ? <div ref='helperContent' className={classnames('helper-content', `content-${expandStatus}`)}>
          {content ? <pre className="pre-html">{html.decode(content)}</pre> : null}
          {linkAddressLable && linkAddress ? <pre className={classnames('pre-html', 'helperLink')} onTouchTap={this.onTouchTap}>{html.decode(linkAddressLable)}</pre> : null}
        </div> : null}
      </div> : null;
  }

  handleExpand(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      expandStatus: this.state.expandStatus == 'fold' ? 'unfold' : 'fold'
    });
  }

  render() {
    const { expandStatus } = this.state;
    const { promptPosition, promptType = 'notice', tipInfo = '' } = this.props;

    return (
      <div className="form-helper-container">
        {promptPosition == 'top' && tipInfo ?
          <div className='tip-area'>
            <HelperTip promptType={promptType} tipInfo={tipInfo} />
          </div> : null}
        {this.renderHelper()}
        {promptPosition == 'bottom' && tipInfo ?
          <div className={classnames('tip-area-bottom', { 'tip-fold': expandStatus == 'fold' })}>
            <HelperTip promptType={promptType} tipInfo={tipInfo} />
          </div> : null}
        {expandStatus !== '' ?
            <div onTouchTap={this.handleExpand}>
                <div className={classnames('helper-expand', '')} >
                    <span className={expandStatus}></span>
                </div>
            </div> : null}
      </div>
    );
  }
}

export default FormHelper;



// WEBPACK FOOTER //
// ./src/components/Form/FormHelper/index.js